var map = {
	"./RCS-logo-color.png": 1184,
	"./RCS-logo.png": 725,
	"./curve-background.jpg": 1363,
	"./curve-background.png": 1364,
	"./curve-background.svg": 1365,
	"./hol-logo-mt.png": 886,
	"./ic-arrow-circle.svg": 1185,
	"./icons/claim_checklist.svg": 809,
	"./icons/claim_rejected.svg": 1366,
	"./icons/download.svg": 1367,
	"./icons/ic-aclamation.svg": 1368,
	"./icons/ic-activity-active.svg": 1369,
	"./icons/ic-activity.svg": 1370,
	"./icons/ic-add-blue.svg": 1371,
	"./icons/ic-add-fill.svg": 1372,
	"./icons/ic-add-white.svg": 1373,
	"./icons/ic-angle-right-darker.svg": 1186,
	"./icons/ic-angle-right.svg": 1374,
	"./icons/ic-archive-box-v2.svg": 1375,
	"./icons/ic-archive-box.svg": 1376,
	"./icons/ic-arrow-down.svg": 563,
	"./icons/ic-arrow-left.svg": 1187,
	"./icons/ic-arrow-right.svg": 1377,
	"./icons/ic-audit.svg": 1378,
	"./icons/ic-book-open.svg": 1379,
	"./icons/ic-calendar-check.svg": 1380,
	"./icons/ic-calendar.svg": 1381,
	"./icons/ic-caret-down-blue.svg": 1382,
	"./icons/ic-caret-down-fill.svg": 1383,
	"./icons/ic-caret-down-fill2.svg": 1384,
	"./icons/ic-caret-down-white.svg": 1385,
	"./icons/ic-caret-down.svg": 1386,
	"./icons/ic-caret-down2.svg": 1387,
	"./icons/ic-caret-right-blue.svg": 1388,
	"./icons/ic-caret-right.svg": 1389,
	"./icons/ic-caret-up.svg": 1390,
	"./icons/ic-check-circle-active.svg": 1391,
	"./icons/ic-checklist.svg": 1392,
	"./icons/ic-claim-success.svg": 1393,
	"./icons/ic-claim.svg": 1394,
	"./icons/ic-close-white.svg": 1395,
	"./icons/ic-close.svg": 1396,
	"./icons/ic-color-picker.svg": 1188,
	"./icons/ic-compliance-inactive.svg": 726,
	"./icons/ic-compliance-monitor-active.svg": 1397,
	"./icons/ic-compliance-monitor.svg": 1398,
	"./icons/ic-comply.svg": 644,
	"./icons/ic-customer-management-active.svg": 1399,
	"./icons/ic-customer-management.svg": 1400,
	"./icons/ic-dashboard-active.svg": 1401,
	"./icons/ic-dashboard.svg": 1402,
	"./icons/ic-document-reminder.svg": 810,
	"./icons/ic-document.svg": 1403,
	"./icons/ic-documents.svg": 1404,
	"./icons/ic-dot-active.svg": 1405,
	"./icons/ic-dot.svg": 1406,
	"./icons/ic-download-fill.svg": 1407,
	"./icons/ic-download-simple.svg": 1408,
	"./icons/ic-download-white.svg": 1409,
	"./icons/ic-download2-white.svg": 1410,
	"./icons/ic-elipsis-h.svg": 1411,
	"./icons/ic-enforced.svg": 1412,
	"./icons/ic-expand-all.svg": 1413,
	"./icons/ic-eye-slash.svg": 1414,
	"./icons/ic-file-search.svg": 1415,
	"./icons/ic-file-text.svg": 1416,
	"./icons/ic-file-white.svg": 1417,
	"./icons/ic-file.svg": 1418,
	"./icons/ic-filter.svg": 1419,
	"./icons/ic-flag-en.svg": 1420,
	"./icons/ic-flag-id.svg": 1421,
	"./icons/ic-folder-move.svg": 1189,
	"./icons/ic-info-blue.svg": 1422,
	"./icons/ic-info.svg": 1190,
	"./icons/ic-input-error.svg": 1423,
	"./icons/ic-magnifying-glass.svg": 1424,
	"./icons/ic-new-fill.svg": 1425,
	"./icons/ic-new-white.svg": 1426,
	"./icons/ic-not-comply.svg": 727,
	"./icons/ic-notif-amended-repealed-obligation.svg": 1191,
	"./icons/ic-notif-audit.svg": 811,
	"./icons/ic-notif-claim.svg": 812,
	"./icons/ic-notif-conditional-obligation.svg": 1192,
	"./icons/ic-notif-continuous-obligation.svg": 1193,
	"./icons/ic-notif-inactive-obligation.svg": 1194,
	"./icons/ic-notif-licensing-obligation.svg": 1195,
	"./icons/ic-notif-new-obligation.svg": 1196,
	"./icons/ic-notif-new-published-obligation.svg": 1197,
	"./icons/ic-notif-periodic-obligation.svg": 1198,
	"./icons/ic-notif-prohibition-obligation.svg": 1199,
	"./icons/ic-pencil.svg": 1427,
	"./icons/ic-refresh-fill.svg": 1428,
	"./icons/ic-refresh-white.svg": 1429,
	"./icons/ic-regframe-active.svg": 1430,
	"./icons/ic-regframe.svg": 1431,
	"./icons/ic-regulation-update.svg": 813,
	"./icons/ic-regulations-active.svg": 1432,
	"./icons/ic-regulations.svg": 1433,
	"./icons/ic-renew.svg": 728,
	"./icons/ic-reset.svg": 1434,
	"./icons/ic-search-white.svg": 1435,
	"./icons/ic-search.svg": 1436,
	"./icons/ic-settings-active.svg": 1437,
	"./icons/ic-settings.svg": 1438,
	"./icons/ic-sort-az-fill.svg": 1439,
	"./icons/ic-sort-az-white.svg": 1440,
	"./icons/ic-sort-time-fill.svg": 1441,
	"./icons/ic-sort-time-white.svg": 1442,
	"./icons/ic-sort-za-fill.svg": 1443,
	"./icons/ic-sort-za-white.svg": 1444,
	"./icons/ic-sort.svg": 1445,
	"./icons/ic-spinner.svg": 1446,
	"./icons/ic-subtopic.svg": 1447,
	"./icons/ic-success-round-green.svg": 1448,
	"./icons/ic-suspend.svg": 1449,
	"./icons/ic-three-dots-blue.svg": 1450,
	"./icons/ic-three-dots.svg": 1451,
	"./icons/ic-three-lines.svg": 1452,
	"./icons/ic-topic.svg": 1453,
	"./icons/ic-trash-can.svg": 1454,
	"./icons/ic-trash-delete.svg": 887,
	"./icons/ic-upload-file-blue.svg": 1455,
	"./icons/ic-upload-simple.svg": 1456,
	"./icons/ic-upload-white.svg": 1457,
	"./icons/ic-upload.svg": 1458,
	"./icons/ic-user-o.svg": 1459,
	"./icons/ic-view-regulation.svg": 666,
	"./icons/ic-warning-danger.svg": 1460,
	"./icons/ic-warning-pink.svg": 1461,
	"./icons/ic-warning.svg": 1462,
	"./icons/ic-x-black.svg": 1463,
	"./icons/ic-x-bold-white.svg": 1464,
	"./icons/useMention.svg": 814,
	"./icons/user.svg": 815,
	"./icons/userAssign.svg": 816,
	"./illustration-login.png": 888,
	"./image-placeholder.svg": 1465,
	"./library-sb.svg": 1466,
	"./logo-vale.jpg": 1467,
	"./notification-sb.svg": 1468,
	"./notification.svg": 1200,
	"./pge-bg.jpg": 1469,
	"./pge-logo.png": 1470,
	"./progress-modal-amended-option-bg.svg": 1471,
	"./rcs-beraucoal-nav.png": 1472,
	"./rcs-pge-nav.png": 1473,
	"./rcs-vale.png": 1474,
	"./search.png": 1475,
	"./sort-by.png": 1476,
	"./triangle-dots-bottom.png": 1477,
	"./triangle-dots-top.png": 1478,
	"./updating-content.png": 1179,
	"./vale-bg.jpg": 1479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 643;